import React from "react";
import PropTypes from "prop-types";
import remark from "remark";
import recommended from "remark-preset-lint-recommended";
import remarkHtml from "remark-html";
import styled from "react-emotion";

const Wrapper = styled.div``;

export const HTMLContent = ({ content, className }) => (
  <Wrapper
    className={className}
    dangerouslySetInnerHTML={{ __html: content }}
  />
);

export const MarkdownStringContent = ({ content, className }) => (
  <Wrapper
    className={className}
    dangerouslySetInnerHTML={{
      __html: remark()
        .use(recommended)
        .use(remarkHtml)
        .processSync(content)
        .toString()
    }}
  />
);

const Content = ({ content, className }) => (
  <Wrapper className={className}>{content}</Wrapper>
);

Content.propTypes = {
  content: PropTypes.string,
  className: PropTypes.string
};

HTMLContent.propTypes = Content.propTypes;

export default Content;



// WEBPACK FOOTER //
// ./src/components/Content.js